import React from 'react';

// Types
type SearchActionType = 'OPEN_DRAWER' | 'CLOSE_DRAWER' | 'TOGGLE_DRAWER';
type SearchAction = { type: SearchActionType; payload?: boolean | string };

type SearchDispatch = (action: SearchAction) => void;

interface SearchState {
  /** @boolean If the profile drawer is open */
  open: boolean;
}

const SearchStateContext = React.createContext<SearchState | undefined>(undefined);
const SearchDispatchContext = React.createContext<SearchDispatch | undefined>(undefined);

const initialState: SearchState = {
  open: false,
};

const sidebarReducer = (state: SearchState, action: SearchAction) => {
  switch (action.type) {
    case 'OPEN_DRAWER':
      return { ...state, open: true };
    case 'CLOSE_DRAWER':
      return { ...state, open: false };
    case 'TOGGLE_DRAWER':
      return { ...state, open: !state.open };
    default:
      return state;
  }
};

export const SearchProvider: React.FC = ({ children }: any) => {
  const [state, dispatch] = React.useReducer(sidebarReducer, initialState);

  return (
    <SearchStateContext.Provider value={state}>
      <SearchDispatchContext.Provider value={dispatch}>{children}</SearchDispatchContext.Provider>
    </SearchStateContext.Provider>
  );
};

export const useSearchState = () => {
  const context = React.useContext(SearchStateContext);
  if (context === undefined) {
    throw new Error('useSearchState must be used within a SearchProvider');
  }
  return context;
};

export const useSearchDispatch = () => {
  const context = React.useContext(SearchDispatchContext);
  if (context === undefined) {
    throw new Error('useSearchDispatch must be used within a SearchProvider');
  }
  return context;
};
